<template>
	<div>
		<ly-datalist url="mechanic" infourl="mechanic_add" title="技师列表" add="yes" addtxt="新建技师">
			<table class="table">
		        <thead>
		          <tr>
		            <th>技师姓名</th>
		            <th>所属门店名称</th>
		            <th>所属门店ID</th>
		            <th>门店电话</th>
		            <th>门店区域</th>
		            <th>微信端车主可见性</th>
		            <th>操作</th>
		          </tr>
		        </thead>
		        <tbody>
		        	<tr v-for="item in data">
			            <td>{{item.name}}</td>
			            <td>{{item.shop_name}}</td>
			            <td>{{item.shop_id}}</td>
			            <td>{{item.shop_phone}}</td>
			            <td>{{item.shop_area}}</td>
			            <td>{{item.is_open_wx ? '是' : '否'}}</td>
			            <td>
			            	<a  v-link="{name:'mechanic_info',params : {mid: item.id}}" class="button">查看</a>
			            	<a href="javascript:;" class="sort-btn" title="向上移动"
			            		@click="sortUp(item.id,$index)"
			            		v-if="$index != 0">
			            		<i class="glyphicon glyphicon-arrow-up"></i>
			            	</a>
			            	<a href="javascript:;" class="sort-btn" title="向下移动" 
			            		@click="sortDown(item.id,$index)"
			            		v-if="$index != (data.length - 1)">
			            		<i class="glyphicon glyphicon-arrow-down"></i> 
			            	</a>
			            </td>
			        </tr>
		        </tbody>
		    </table>
		</ly-datalist>
	</div>
</template>
<script>
	var Common = require('../utils/Common.js');
	var Http = require('../utils/HttpHelper.js');
	/**
	* 组件对象
	*/
	var Component = {
		data : function(){
			return {
				data : []
			}
		},
		components :  {
			'ly-datalist' : require('../components/Datalist.vue')
		},
		
		methods : {
			/**
			* 向上移动
			*/
			sortUp : function(id,index){
				this.data = Common.sortArr(this.data,index,index - 1);
				Http.mechanic.up({
					data : {
						id : id
					}
				});
			},
			/**
			* 向下的移动
			*/
			sortDown : function(id,index){
				this.data = Common.sortArr(this.data,index,index + 1);
				Http.mechanic.down({
					data : {
						id : id
					}
				});
			}
		},
		events : {
			datalist : function(data){
				this.data = data;
			}
		}
	};
	module.exports = Component;
</script>


/** WEBPACK FOOTER **
 ** mechanic_list.vue?750382be
 **/